import intlTelInput from 'intl-tel-input';
import { Iso2 } from 'intl-tel-input/data';
import { reportModuleImportError } from '../general/utils/module-import';

if (!(Object as any).hasOwn) {
  (Object as any).hasOwn = (obj: object, key: PropertyKey) => Object.prototype.hasOwnProperty.call(obj, key);
}

if (!Element.prototype.replaceChildren) {
  Element.prototype.replaceChildren = function (...nodes: (Node | string)[]) {
    while (this.firstChild) {
      this.removeChild(this.firstChild);
    }
    if (nodes.length) {
      this.append(...nodes);
    }
  };
}

(document.querySelectorAll('.expatmodal, .consultation-new-expat, .phoneConsultation-block, .qqc-offer-generation-block, #chat-modal') as NodeListOf<HTMLElement>).forEach(expatBlock => {
  const phoneInput = expatBlock.querySelector('.expat-phone input') as HTMLInputElement;
  if (!phoneInput) {
    return;
  }

  createItiPhoneInput(phoneInput, 'us', expatBlock);

  if (!expatBlock.classList.contains('consultation-new-expat')) {
    const expatForm = expatBlock.querySelector('form');
    if (!expatForm) {
      return;
    }
    const incomeField = expatForm.querySelector('select[name="income"]') as HTMLSelectElement;
    const employmentField = expatForm.querySelector('select[name="employment"]') as HTMLSelectElement;
    const dateSelect = expatForm.querySelector('.dateSelect') as HTMLSelectElement;
    const timeSelect = expatForm.querySelector('.timeSelect') as HTMLSelectElement;

    if (!incomeField || !employmentField || !dateSelect || !timeSelect) {
      return;
    }

    /* Show Appointment on higher income only */
    [incomeField, employmentField].forEach(field =>
      field.addEventListener('change', e => {
        const income = incomeField.value;
        const employment = employmentField.value;
        timeSelect.required = false;
        timeSelect.disabled = true;
        dateSelect.value = '';
        timeSelect.value = '';
        dateSelect.dispatchEvent(new Event('update'));
        timeSelect.dispatchEvent(new Event('update'));

        if (employment !== 'pensioner' && employment !== 'unemployed' && (income === 'more' || income === '30to40' || income === '40to60')) {
          expatForm.querySelector('.appoint-container')?.classList.add('active');
          expatBlock.querySelector('.list')?.classList.add('large');
          dateSelect.required = true;
        } else {
          if (expatForm.querySelector('.appoint-container')?.classList.contains('active')) {
            expatForm.querySelector('.appoint-container')?.classList.remove('active');
            expatBlock.querySelector('.list')?.classList.remove('large');
          }
          dateSelect.required = false;
        }
      })
    );
  }
});

export function createItiPhoneInput(phoneInput: HTMLInputElement, initialCountry: Iso2, block: HTMLElement) {
  const inputContainer = phoneInput.parentElement;
  const iti = intlTelInput(phoneInput, {
    initialCountry: initialCountry,
    countryOrder: [initialCountry, 'us', 'gb', 'de'],
    containerClass: inputContainer!.className,
    countrySearch: false,
    strictMode: true,
    numberDisplayFormat: 'NATIONAL',
    matchDropdownWidth: false,
    separateDialCode: false,
    // intl-tel-input swallows loadUtils failures internally (attachUtils().catch(() => {})),
    // so report unexpected ones here first - it still rethrows, leaving that behaviour intact.
    // A single retry covers transient chunk-load failures (flaky mobile network, CDN cache still
    // propagating a new deploy) before we give up and report.
    loadUtils: () =>
      import('intl-tel-input/utils')
        .catch(() => import('intl-tel-input/utils'))
        .catch(error => {
          reportModuleImportError(error, { chunk: 'intl-tel-input-utils' });
          throw error;
        })
  });
  inputContainer!.className = '';

  phoneInput.addEventListener('open:countryselector', () => {
    const countryDropdown = inputContainer!.querySelector('button + div.iti__country-selector ') as HTMLDivElement;
    if (!countryDropdown) return;
    countryDropdown.style.width = inputContainer!.offsetWidth + 'px';
  });

  phoneInput.addEventListener('close:countryselector', () => {
    const countryDropdown = inputContainer!.querySelector('button + div.iti__country-selector ') as HTMLDivElement;
    if (!countryDropdown) return;
    countryDropdown.removeAttribute('style');
  });

  const prefixInput = inputContainer!.querySelector('input[name="phone_prefix"]') as HTMLInputElement;
  const iso2Input = inputContainer!.querySelector('input[name="iso2_code"]') as HTMLInputElement;
  const countryPrefix = document.createElement('span');

  countryPrefix.classList.add('otto-prefix');
  const updatePrefix = () => {
    const countryInfo = iti.getSelectedCountry();
    if (countryInfo) {
      countryPrefix.textContent = `+${countryInfo.dialCode}`;
      if (prefixInput) {
        prefixInput.value = `+${countryInfo.dialCode}`;
      }
      if (iso2Input && countryInfo.iso2) {
        iso2Input.value = countryInfo.iso2;
      }
    }
  };
  updatePrefix();
  phoneInput.addEventListener('countrychange', updatePrefix);

  // rearrange html so that css can apply
  const itiContainer = block.querySelector('.iti');
  if (itiContainer) {
    itiContainer.append(countryPrefix);
    itiContainer.append(phoneInput);
  }
}
